import { CoordinatorService } from './coordinator.service';

export class ScriptSettingsGroup {
    #coords: CoordinatorService;
    private _callMap = new Map<string, string>();

    constructor(
        coords: CoordinatorService,
        public tag: string,
    ) {
        this.#coords = coords;

        switch (tag) {
            case 'itemDetail':
                this._callMap.set('expand', 'detail-panel');
                this._callMap.set('collapse', 'detail-panel');
                this._callMap.set('hide', 'minimize-panel');
                this._callMap.set('show', 'minimize-panel');
                break;
            case 'itemList':
                this._callMap.set('abstract', 'inclAbstr');
                this._callMap.set('subsets', 'inclViews');
                break;
            case 'keywords':
                this._callMap.set('hide', 'keywords-highlight-off');
                this._callMap.set('show', 'keywords-highlight-off');
                break;
            default:
                break;
        }
    }

    private get _pin() {
        return this.#coords.pin$.misc!;
    }

    private _run({ method, suffix, isOn }: { method: string; suffix?: string; isOn: boolean }) {
        let tag = this._callMap.get(method);
        if (tag) {
            if (tag.startsWith('keyword')) this.#coords.highlight$.reset();
            suffix && (tag += `-${suffix}`);
            isOn ? this._pin.on(tag) : this._pin.off(tag);
        } else console.log(`Unknown setting for ${this.tag}`, method);

        this.#coords.display$.markForCheck();
    }

    abstract(isOn = true) {
        this._run({ method: 'abstract', isOn });
    }

    subsets(isOn = true) {
        this._run({ method: 'subsets', isOn });
    }

    expand(suffix: string) {
        const isOn = true;
        this._run({ method: 'expand', isOn, suffix });
    }

    collapse(suffix: string) {
        const isOn = false;
        this._run({ method: 'collapse', isOn, suffix });
    }

    show(suffix: string) {
        const isOn = false;
        this._run({ method: 'show', isOn, suffix });
    }
    hide(suffix: string) {
        const isOn = true;
        this._run({ method: 'hide', isOn, suffix });
    }
}
